import React from "react";

import { Checkbox, Col, Row, Timeline, Typography } from "components";

export const TimelineTab = ({ createTimeline, setShow, show, timeline, user }) => {
  const toggleTimeline = (item) => {
    show[item] = !show[item];

    setShow(show);

    createTimeline(user);
  };

  return (
    <>
      <Row>
        <Col>
          <Row>
            <Col sm={24} md={6}>
              <Checkbox checked={show.account} onChange={() => toggleTimeline("account")}>
                View account activity
              </Checkbox>
            </Col>
            <Col sm={24} md={6}>
              <Checkbox checked={show.views} onChange={() => toggleTimeline("views")}>
                View page activity
              </Checkbox>
            </Col>
            <Col sm={24} md={6}>
              <Checkbox checked={show.methods} onChange={() => toggleTimeline("methods")}>
                View method activity
              </Checkbox>
            </Col>
          </Row>
          <Row className="margin-top-200">
            <Col className="center">
              <Timeline
                mode="alternate"
                items={timeline.map((item) => ({
                  icon: item.icon,
                  content: (
                    <>
                      <Typography
                        variant="paragraph-m"
                        style={{
                          fontSize: "0.9rem",
                          maxWidth: "600px",
                          display: "inline-block",
                        }}
                      >
                        {item.text}
                      </Typography>
                      <br />
                      <Typography variant="paragraph-s" color="grey-600">
                        {item.date}
                      </Typography>
                    </>
                  ),
                }))}
              />
            </Col>
          </Row>
        </Col>
      </Row>
    </>
  );
};
